export default __webpack_public_path__ + "static/media/zen.b9ea8187.png";